module.exports = __webpack_public_path__ + "static/img/frame-large.9c44b577.png";